import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { setAppLanguage, AppDispatch } from "@lib/store";
import { AppLanguage } from "@lib/utils";
import { i18nInitOptions } from "@lib/utils/src/util/i18n";
import "intl-pluralrules";

export const initI18Next = (dispatch: AppDispatch) => {
  i18next.on("languageChanged", lng => {
    document.documentElement.lang = lng;
    dispatch(setAppLanguage(<AppLanguage>lng));
  });

  i18next.use(initReactI18next).use(LanguageDetector).init(i18nInitOptions);
};

export default i18next;
